import { GlobalSearchApiResponse } from '@/redux/lookup'

export const trendingSearchData: Partial<GlobalSearchApiResponse> = {
  trending: [
    {
      id: 'gbp',
      name: 'Green Bay Packers',
      url: '/nfl-travel-packages/green-bay-packers',
    },
    {
      id: 'dcb',
      name: 'Dallas Cowboys',
      url: '/nfl-travel-packages/dallas-cowboys',
    },
    {
      id: 'bb',
      name: 'Buffalo Bills',
      url: '/nfl-travel-packages/buffalo-bills',
    },
    {
      id: 'lvr',
      name: 'Las Vegas Raiders',
      url: '/nfl-travel-packages/las-vegas-raiders',
    },
    {
      id: 'tbj',
      name: 'Toronto Blue Jays',
      url: '/mlb-travel-packages/toronto-blue-jays',
    },
    {
      id: 'cc',
      name: 'Chicago Cubs',
      url: '/mlb-travel-packages/chicago-cubs',
    },
    {
      id: 'brs',
      name: 'Boston Red Sox',
      url: '/mlb-travel-packages/boston-red-sox',
    },
    // {
    //   id: 'cchla',
    //   name: 'Coachella',
    //   url: '/coachella-music-festival-travel-packages',
    // },
    // {
    //   id: 'sch',
    //   name: 'Stagecoach',
    //   url: '/stagecoach-country-music-festival-travel-packages',
    // },
    {
      id: 'lad',
      name: 'Los Angeles Dodgers',
      url: '/mlb-travel-packages/los-angeles-dodgers',
    },
    {
      id: 'f1',
      name: 'Formula 1',
      url: '/formula-1-travel-packages/formula-1',
    },
    {
      id: 'mw',
      name: 'Morgan Wallen',
      url: '/morgan-wallen-travel-packages',
    },
    {
      id: 'nyy',
      name: 'New York Yankees',
      url: '/mlb-travel-packages/new-york-yankees',
    },
    {
      id: 'ufc',
      name: 'UFC',
      url: '/mixed-martial-arts-travel-packages/ufc-ultimate-fighting-championship',
    },
  ],
}
